// ChangeRequestApproval API
import {
    RequestConfigFunction,
} from 'app/types/request.types'

type OrderRequests = {
    getChangeRequestApproval: RequestConfigFunction<{ orderNumber: string }>,
    changeStatus: RequestConfigFunction<{ orderNumber: string }>,
}

const changeRequestApprovalRequests: OrderRequests = {
    getChangeRequestApproval: ({
        orderNumber,
    }) => {
        return {
            url: `order/${orderNumber}/change-request-approval`,
            method: 'GET',
        }
    },
    changeStatus: ({
        orderNumber,
    }) => {
        return {
            url: `order/${orderNumber}/change-request-approval`,
            method: 'PATCH',
        }
    },
}

export default changeRequestApprovalRequests
